import { render, staticRenderFns } from "./DiscrepancyReport.vue?vue&type=template&id=4884b01a"
import script from "./DiscrepancyReport.vue?vue&type=script&lang=js"
export * from "./DiscrepancyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports